import {twMerge} from '../../../../common/twMerge';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonLayoutProps} from '../../type';

export function Home({trackEventObj, children, className}: CommonLayoutProps) {
  return (
    <div
      className={twMerge('flex grow flex-col', className)}
      {...putTiaraObjectProps(trackEventObj)}
    >
      {children}
    </div>
  );
}
